import type { CacheStorageOptions } from '@/shared/lib/hooks/use-cache-storage';
import { UserAttributesAPI } from '@/entities/user/user-attribute';
import { useArrayMap } from '@/shared/lib/hooks/array-map';
import { useCacheStorage } from '@/shared/lib/hooks/use-cache-storage';
import { Page } from '@/shared/api/pagination';
import { UserAttribute } from '@/entities/user/user-attribute';
import { type UseQueryResult } from '@tanstack/react-query';
import { useMemo } from 'react';

export const userAttributesQueryConfig: CacheStorageOptions<
  Page<UserAttribute>
> = {
  meta: { cacheStorageEvent: 'user-attributes' },
  queryKey: ['user-attributes'],
  queryFn: ({ signal }) =>
    UserAttributesAPI.getAttributes({
      params: { size: -1 },
      signal,
      timeout: 15000,
    }).then((res) => res.data),
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  cacheTime: Infinity,
};
export const useUserAttributesStorage = () => {
  return useCacheStorage<Page<UserAttribute>>({
    queryConfig: userAttributesQueryConfig,
  });
};
export const useUserAttributesMap = <T extends Map<string, UserAttribute>>(
  key = 'name',
) => {
  const { data, ...rest } = useUserAttributesStorage();
  const items = data?.items || [];
  const memoizedData = useArrayMap(items, key);
  return useMemo(
    () => ({ ...rest, data: memoizedData }),
    [memoizedData, rest],
  ) as UseQueryResult<T>;
};